/**
 * Open an end user's profile drawer from anywhere: a distinct_id in Traces, a
 * run or conversation drawer, the Users list, a Lucid answer, search. One
 * window event, one host (UserProfileHost, mounted once in the Dashboard
 * shell), so no page has to own the drawer or navigate away to show a user.
 */
export const OPEN_USER_PROFILE = 'trodo:user:open';

export function openUserProfile(distinctId) {
  if (distinctId == null || distinctId === '' || typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_USER_PROFILE, { detail: { distinctId: String(distinctId) } }));
}
